export function profileReturnDestination(next: string | null): string {
  if (!next?.startsWith("/")) return "/projects";
  // URL parsing removes tabs/newlines and treats backslashes as slashes.
  if (/^\/[\\/]/.test(next.replace(/[\t\r\n]/g, ""))) return "/projects";
  const base = "https://bajuben.invalid";
  let destination: URL;
  try { destination = new URL(next, base); }
  catch { return "/projects"; }
  if (destination.origin !== base || /^\/profile\/setup\/?$/.test(destination.pathname)) return "/projects";
  return destination.pathname + destination.search + destination.hash;
}
